import { render, staticRenderFns } from "./ProcessPost.vue?vue&type=template&id=c37372ae&scoped=true&"
import script from "./ProcessPost.vue?vue&type=script&lang=js&"
export * from "./ProcessPost.vue?vue&type=script&lang=js&"
import style0 from "./ProcessPost.vue?vue&type=style&index=0&id=c37372ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37372ae",
  null
  
)

export default component.exports